import { AdminLayout } from '@/components/layouts'
import CommunityForm from './CommunityForm'

interface CommunityData {
  id: number
  slug: string
  name: string
  description: string
  active: boolean
  specialties: string[]
}

interface EditProps {
  community: CommunityData
  specialties: string[]
}

export default function Edit({ community, specialties }: EditProps) {
  return (
    <AdminLayout
      title={`Modifier ${community.name}`}
      breadcrumbs={[
        { label: 'Communautés', href: '/admin/communities' },
        { label: community.name, href: `/admin/communities/${community.slug}` },
        { label: 'Modifier' }
      ]}
    >
      <div className="max-w-2xl">
        <CommunityForm community={community} specialties={specialties} isEdit />
      </div>
    </AdminLayout>
  )
}
